import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "bg-grey-lighten-4 rounded p-3",
  "data-cy": "agent-identity"
}
const _hoisted_2 = { class: "font-weight-medium" }
const _hoisted_3 = { class: "text-caption text-grey-darken-1 mt-1" }
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-caption text-amber-darken-4 mt-2 mb-0"
}

import LlStatusBadge from '@/components/LlStatusBadge.vue';
import type { AgentAccessAgent } from '../models/agentAccessTypes';

// The address is shown alongside the name everywhere an agent is named, never replaced by it: the
// name is whatever a publisher chose to call itself, the address is what cannot be faked.

export default /*@__PURE__*/_defineComponent({
  __name: 'AgentIdentity',
  props: {
    agent: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.agent.name), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.agent.origin), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(LlStatusBadge, {
        tone: __props.agent.isVerifiedPublisher ? 'green' : 'amber'
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.agent.isVerifiedPublisher ? 'Verified publisher' : 'Publisher not verified'), 1)
        ]),
        _: 1
      }, 8, ["tone"])
    ]),
    (!__props.agent.isVerifiedPublisher)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, " LeanLaw has not verified this publisher. Check the address is one you recognise before approving. "))
      : _createCommentVNode("", true)
  ]))
}
}

})